// src/App.js
import React from 'react';
import { Helmet } from 'react-helmet';
import LandingPage from './unAuth/LandingPage';
import { faqs } from './unAuth/components/FAQ';
import './App.css';
import './firebase';

const SITE_URL = 'https://timestampgn.com';

const webAppSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Timestampgn',
  url: SITE_URL,
  description: 'Free AI-powered YouTube timestamp generator. Create shareable chapter markers for any video in seconds. Paste a link, get timestamps, copy to your description.',
  applicationCategory: 'MultimediaApplication',
  operatingSystem: 'Any',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

const jsonLd = [webAppSchema, faqSchema];

function App() {
  return (
    <div className="app-structure-container">
      <Helmet>
        <title>Timestampgn — Free AI YouTube Timestamp Generator</title>
        <meta
          name="description"
          content="Free AI YouTube timestamp generator. Create shareable chapter markers for any video in seconds. Paste a link, get timestamps, copy to your description. How it works & FAQ."
        />
        <meta
          name="keywords"
          content="YouTube timestamp generator, AI timestamps, video chapters, chapter markers, free timestamp tool, YouTube description, video timestamps"
        />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:title" content="Timestampgn — Free AI YouTube Timestamp Generator" />
        <meta property="og:description" content="Free AI YouTube timestamp generator. Create shareable chapter markers for any video in seconds. Paste a link, get timestamps, copy to your description." />
        <meta property="og:image" content={`${SITE_URL}/logo512.png`} />
        <meta property="og:site_name" content="Timestampgn" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Timestampgn — Free AI YouTube Timestamp Generator" />
        <meta name="twitter:description" content="Free AI YouTube timestamp generator. Create shareable chapter markers for any video in seconds. Paste a link, get timestamps, copy to your description." />
        <meta name="twitter:image" content={`${SITE_URL}/logo512.png`} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <LandingPage />
    </div>
  );
}

export default App;
